<template>
  <el-form label-width="180px" class="show" label-position="right">
    <el-form-item label="Id">{{ user.id }}</el-form-item>
    <el-form-item label="Email">{{ user.email }}</el-form-item>
    <el-form-item label="Roles">
      <div v-for="role in user.roles" :key="role">{{ roleLabel(role) }}</div>
    </el-form-item>
    <el-form-item label="Created at">{{ user.created | formatDatetime }}</el-form-item>
    <el-form-item label="Updated at">{{ user.modified | formatDatetime }}</el-form-item>

    <div class="mt-3">
      <el-button
        v-if="hasRoleToUpdate"
        icon="el-icon-fa-pencil-square-o"
        @click="edit()"
        type="primary"
      >{{$t('table.edit')}}</el-button>
      <el-button
        v-if="hasRoleToReadLogs"
        icon="el-icon-fa-history"
        @click="history()"
        type="infor"
      >{{$t('table.history')}}</el-button>
      <el-button
        v-if="hasRoleToReadActivity"
        icon="el-icon-fa-eye"
        @click="activity()"
        type="infor"
      >Activity</el-button>
    </div>
  </el-form>
</template>

<script>
import { mapGetters } from "vuex";
import Roles from "@/auth/roles";

export default {
  name: "app-user-detail",

  props: {
    user: Object
  },

  computed: {
    ...mapGetters({
      hasRoleToUpdate: "user/hasRoleToUpdate",
      hasRoleToReadLogs: "user/hasRoleToReadLogs",
      hasRoleToReadActivity: "user/hasRoleToReadActivity"
    })
  },

  methods: {
    history() {
      this.$router.push({
        name: "userHistorySingle",
        params: { id: this.user.id }
      });
    },

    activity() {
      this.$router.push({
        name: "userActivity",
        params: { id: this.user.id }
      });
    },

    edit() {
      this.$router.push({
        name: "userEdit",
        params: { id: this.user.id, previous: "show" }
      });
    },

    roleLabel(roleId) {
      return Roles.labelOf(roleId);
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/user/user-detail.vue?443b9bb0